import { render, staticRenderFns } from "./alipayIsv.vue?vue&type=template&id=2b751cc9&scoped=true&"
import script from "./alipayIsv.vue?vue&type=script&lang=js&"
export * from "./alipayIsv.vue?vue&type=script&lang=js&"
import style0 from "./alipayIsv.vue?vue&type=style&index=0&id=2b751cc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b751cc9",
  null
  
)

export default component.exports